var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step1" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("label", { staticClass: "header" }, [
          _vm._v("Select an Appointment Type to See Availability"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "options" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.type,
                expression: "type",
              },
            ],
            attrs: { type: "radio", id: "FollowUp", value: "FollowUp" },
            domProps: { checked: _vm._q(_vm.type, "FollowUp") },
            on: {
              change: function ($event) {
                _vm.type = "FollowUp"
              },
            },
          }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.type,
                expression: "type",
              },
            ],
            attrs: {
              type: "radio",
              id: "FreeConsultation",
              value: "FreeConsultation",
            },
            domProps: { checked: _vm._q(_vm.type, "FreeConsultation") },
            on: {
              change: function ($event) {
                _vm.type = "FreeConsultation"
              },
            },
          }),
          _vm._v(" "),
          _vm._m(1),
        ]),
        _vm._v(" "),
        _vm.type
          ? [
              _c("div", { staticClass: "date" }, [
                _c(
                  "button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.changeMonth("prev", true)
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        alt: "back",
                        src: "images/left-arrow-white.svg",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("label", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.calendar.month) +
                      " " +
                      _vm._s(_vm.calendar.year)
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.changeMonth("next", true)
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        alt: "next",
                        src: "images/right-arrow-white.svg",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "weeks" }, [
                _c(
                  "button",
                  {
                    staticClass: "action",
                    on: {
                      click: function ($event) {
                        return _vm.changeWeek("prev")
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: { alt: "back", src: "images/left-arrow-gray.svg" },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "days" },
                  _vm._l(_vm.calendar.week, function (day) {
                    return _c(
                      "button",
                      {
                        staticClass: "day",
                        class: [
                          _vm.getDayState(day),
                          { "out-of-bounds": day.month !== _vm.calendar.month },
                        ],
                        attrs: { disabled: day.month !== _vm.calendar.month },
                        on: {
                          click: function ($event) {
                            return _vm.selectDay(day)
                          },
                        },
                      },
                      [
                        _c("label", [_vm._v(_vm._s(day.title))]),
                        _vm._v(" "),
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.helpers().formatterDayShorthand(day.date)
                            )
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "action",
                    on: {
                      click: function ($event) {
                        return _vm.changeWeek("next")
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        alt: "next",
                        src: "images/right-arrow-gray.svg",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "timeslots" },
                _vm._l(_vm.activeDay.timeslots, function (timeslot) {
                  return _c(
                    "button",
                    {
                      class: [{ active: _vm.selectedTimeslot === timeslot }],
                      on: {
                        click: function ($event) {
                          _vm.selectedTimeslot = timeslot
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.helpers().formatterTime(timeslot.dateTime)
                          ) +
                          "\n\t\t\t\t"
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.unavailable
                ? _c("label", { staticClass: "notice" }, [
                    _vm._v(
                      "We are sorry, but we have no available appointments for this period. Please choose a different period"
                    ),
                  ])
                : _vm._e(),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "footer-actions" }, [
      _c("button", { staticClass: "btn-beltone xl disabled" }, [
        _vm._v("Back"),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-beltone xl",
          class: { disabled: _vm.selectedTimeslot === null },
          on: {
            click: function ($event) {
              return _vm.nextStep()
            },
          },
        },
        [_vm._v("Continue")]
      ),
    ]),
    _vm._v(" "),
    _c("label", { staticClass: "disclaimer" }, [
      _vm._v(
        "CAN'T FIND A DAY/TIME THAT WORKS FOR YOU? CALL US TO SCHEDULE AN APPOINTMENT."
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "FollowUp" } }, [
      _c("strong", [_vm._v("FOLLOW-UP")]),
      _vm._v(" - CURRENT PATIENTS (30 MIN.)"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "FreeConsultation" } }, [
      _c("strong", [_vm._v("FREE CONSULTATION")]),
      _vm._v(" - NEW PATIENTS (90 MIN.)"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }